import { createContext } from "react";

export type AuthContextType = {
  username: string | undefined,
  token: string | undefined,
  name: string | undefined,
  isPlayground: boolean,
  setPlaygorund: (val: boolean) => void
  onLogin: (user: string, token: string, name: string) => void,
  onLogout: () => void
}

export const AuthContext = createContext<AuthContextType>({
  username: undefined,
  name: undefined,
  token: undefined,
  isPlayground: false,
  setPlaygorund: () => {},
  onLogin: () => {},
  onLogout: () => {}
})
